import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './landing/Navbar';
import Hero from './landing/Hero';
import IntegrationsSection from './landing/IntegrationsSection';
import ProblemSection from './landing/ProblemSection';
import GapSection from './landing/GapSection';
import DiscoverySection from './landing/DiscoverySection';
import HowItWorks from './landing/HowItWorks';
import SolutionsSection from './landing/SolutionsSection';
import InvoiceDemo from './landing/InvoiceDemo';
import BenefitsSection from './landing/BenefitsSection';
import AdditionalServices from './landing/AdditionalServices';
import FinalCTA from './landing/FinalCTA';
import Footer from './landing/Footer';

const LandingPage: React.FC = () => {
  const location = useLocation();

  // When navigating to /#section from a sub-page, scroll to the target
  // section after the landing page has rendered.
  useEffect(() => {
    if (location.hash) {
      // Small delay to allow the page to render before scrolling.
      const timer = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen overflow-hidden bg-brand-gradient text-white">
      <Navbar />
      <main>
        <Hero />
        <IntegrationsSection />
        <ProblemSection />
        <GapSection />
        <DiscoverySection />
        <HowItWorks />
        <SolutionsSection />
        <InvoiceDemo />
        <BenefitsSection />
        <AdditionalServices />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
